module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iUUW0"))).then(() => parcelRequire('hEqeo'));